import { useState, useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { getApprovalSummary, getApprovalSummaryCount } from '../services/approvalsService';
import { shouldRefreshApprovalsBadge, APPROVALS_COUNT_EVENT } from './approvalsBadge';

// Görev 7 — sol menü tek "Onaylarım" yaprağının rozeti. usePerformanceInboxBadge
// ile AYNI yapı: İLK yüklemede sayı GET /v1/approvals/summary/count'tan gelir
// (60 sn kullanıcı başına önbellekli, bkz. services/approvalsService.
// getApprovalSummaryCount), panel kendi kesin toplamını APPROVALS_COUNT_EVENT
// ile yayınlayınca rozet TTL beklemeden onu ANINDA benimser.
//
// `enabled` false iken (hiçbir onay kategorisi yok / preboarding kilidi) HİÇ
// istek atılmaz — menü öğesi de zaten görünmez. İstek skipErrorToast ile
// sessizdir: arka plan okuması kullanıcıya sahte hata toast'ı gösteremez.
export default function useApprovalsBadge(enabled) {
  const [count, setCount] = useState(0);
  const { pathname } = useLocation();
  const prevPathRef = useRef(null);
  const [refreshTick, setRefreshTick] = useState(0);

  useEffect(() => {
    const prev = prevPathRef.current;
    prevPathRef.current = pathname;
    if (shouldRefreshApprovalsBadge(prev, pathname)) setRefreshTick((p) => p + 1);
  }, [pathname]);

  useEffect(() => {
    if (!enabled) {
      setCount(0);
      return undefined;
    }
    let cancelled = false;
    const applyResult = (res) => {
      if (cancelled) return;
      setCount(res.data?.status ? (res.data.data?.total || 0) : 0);
    };
    const onError = () => { if (!cancelled) setCount(0); };

    // İncelemede bulunan bayatlık: refreshTick>0 kullanıcının BİR ONAY
    // ROTASINDAN AZ ÖNCE ÇIKTIĞI, yani sayının tam da o an değişmiş olabileceği
    // an demek. getApprovalSummaryCount() 60 sn kullanıcı başına önbelleklidir
    // (bkz. ApprovalSummaryDataAccess.GetSummaryTotal) — o pencerede istek
    // atılırsa önbellek isabet eder ve rozet ONAYLANMIŞ İŞLERİ HÂLÂ SAYAR.
    // Açık tazelemede bu yüzden önbelleksiz getApprovalSummary()'yi ve onun
    // kesin data.total'ını kullanıyoruz; yalnız İLK yükleme (refreshTick===0)
    // ucuz önbellekli sayaçtan beslenir. Bedeli: rota çıkışı başına ~11 kategori
    // sorgusu — ama bu yalnız onay rotasından çıkışlarda olur (nadir), doğru
    // takas budur.
    if (refreshTick > 0) {
      getApprovalSummary({ skipErrorToast: true }).then(applyResult).catch(onError);
    } else {
      getApprovalSummaryCount().then(applyResult).catch(onError);
    }
    return () => { cancelled = true; };
  }, [enabled, refreshTick]);

  // Sayfanın yayınladığı kesin sayı önbelleği ezer.
  useEffect(() => {
    if (!enabled) return undefined;
    const onExactCount = (e) => {
      const exact = e?.detail?.count;
      if (typeof exact === 'number') setCount(exact);
    };
    window.addEventListener(APPROVALS_COUNT_EVENT, onExactCount);
    return () => window.removeEventListener(APPROVALS_COUNT_EVENT, onExactCount);
  }, [enabled]);

  return count;
}
